(function () {
  'use strict';

  angular
    .module('component.addtocart-quantity', [])

    .component('buttonAddToCartQuantity', {
      require: {
        productCtrl: '?^^productDetail',
        quotationCtrl: '?^^accountAdvancedQuotations'
      },
      bindings: {
        isProductButton: '<?',
        isCartButton: '<?',
        isQuotationButton: '<?',
        idQuotation: '<?',
        isModalButton: '<?',
        modalItem: '=',
        action: '&?',
        size: '@?',
        btnClass: '@',
        idLine: '<?',
        commentLine: '@?',
        id: '<idProduct',
        isPrimary: '<',
        addToCartActive: '<?',
        allowAddToCart: '<',
        productQuantity: '<',
        min: '<',
        step: '<',
        price: '<productPrice',
        designation: '@productDesignation',
        img: '@productImg',
        url: '@productUrl',
        titleAdd: '@?',
        titleAlert: '@?',
        titleDetail: '@?',
        titleDeleteOk: '@?',
        titleResultOk: '@?',
        titleModifyOk: '@?',
        tooltip: '@',
        modalCtrl: '<',
        toastAdd: '<?',
        device: '<',
        idReplacementProduct: '<?',
        modalReplacementTitle: '@?',
        modalReplacementText: '@?'
      },
      templateUrl: 'component.addtocart-quantity.tpl',
      /* @ngInject */
      controller: ["$scope", "$timeout", "$location", "toastr", "AppService", "QuotationService", "ModalService", "RoutesService", function ($scope, $timeout, $location, toastr, AppService, QuotationService, ModalService, RoutesService) {
        var ctrl = this,
          showTTCPrice = true,
          unwatch = null,
          addTimeout;

        ctrl.$onInit = function () {
          ctrl.min = ctrl.min || 1;
          ctrl.step = ctrl.step || 1;

          if (ctrl.addToCartActive === undefined) {
            ctrl.addToCartActive = true;
          }

          if (ctrl.productQuantity) {
            setItemQuantity(ctrl.productQuantity);
          }

          if (ctrl.isProductButton) {
            ctrl.defaultTooltip = ctrl.tooltip;
            $scope.$on('updateTooltip', function (event, tooltip) {
              ctrl.tooltip = tooltip || ctrl.defaultTooltip;
            });

            $scope.$on('updateComment', function (event, hash) {
              ctrl.commentLine = hash;
              getItemQuantityInCart();
            });
          }

          if (ctrl.isModalButton) {
            ctrl.showLoader = true;
          }

          AppService.getParams()
            .then(function (params) {
              showTTCPrice = params.Visitor.CardType.ShowTTCPrice;
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        ctrl.$onDestroy = function () {
          if (unwatch) {
            unwatch();
          }
        };

        ctrl.openQuickView = function () {
          ModalService.show(
            '/Template/Modal/ModalQuickView',
            {
              url: ctrl.url,
              windowClass: 'modal-quick-view'
            },
            'lg',
            'modalQuickViewCtrl',
            null,
            ctrl.device,
            null
          );
        };

        ctrl.addToCart = function (products, quantity) {
          if (!products) return;

          if (ctrl.idReplacementProduct) {
            ModalService.show(
              '/Template/Modal/ModalQuickView',
              {
                url: 'choose-p-' + ctrl.idReplacementProduct,
                selectReplacement: true,
                windowClass: 'modal-quick-view'
              },
              'xl',
              'modalQuickViewCtrl',
              null,
              ctrl.device,
              {
                modalTitle: ctrl.modalReplacementTitle,
                modalText: ctrl.modalReplacementText
              }
            );
          } else {
            if (ctrl.isCartButton && products[0].quantity < 0) {
              removeCartLine(products, quantity);
            } else if (ctrl.isQuotationButton && (ctrl.productQuantity + products[0].quantity) <= 0) {
              removeQuotationLine(products, quantity);
            } else {
              addToCart(products, quantity);
            }
          }
        };

        ctrl.minus = function () {
          ctrl.quantity = setValue(ctrl.quantity - ctrl.step);
        };

        ctrl.plus = function () {
          if (!ctrl.addToCartActive) return;
          ctrl.quantity = setValue(ctrl.quantity + ctrl.step);
        };

        ctrl.blur = function () {
          if (ctrl.quantity === '') {
            ctrl.quantity = ctrl.cartQuantity;
            return;
          }
          ctrl.quantity = setValue(ctrl.quantity);
        };

        ctrl.keypress = function (event) {
          if (event.which === 13) {
            event.target.blur();
          }
        };

        // Events
        $scope.$on('cartUpdate', function () {
          if (ctrl.modalItem && ctrl.modalItem.fromClassicBtn) {
            setItemQuantity(ctrl.quantity);
          } else {
            if (!ctrl.showLoader || ctrl.isModalButton) {
              getItemQuantityInCart();
            }
          }
        });

        $scope.$watch('$ctrl.id', function () {
          if (!ctrl.productQuantity) {
            getItemQuantityInCart();
          }
        });

        // Functions
        function getItemQuantityInCart() {
          AppService.itemQuantityInCart(ctrl.id, ctrl.commentLine || '')
            .then(function (value) {
              setItemQuantity(value);
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function setItemQuantity(value) {
          ctrl.cartQuantity = value;
          ctrl.productQuantity = value;
          ctrl.quantity = value;
          ctrl.isInCart = value > 0;
          ctrl.showLoader = false;
          ctrl.ready = true;
          if (ctrl.isProductButton) {
            ctrl.productCtrl.setInputQuantity(value);
          }
        }

        function setValue(val) {
          watchValue();
          if (val === '') return val;

          val = double(parseFloat(String(val).replace(',', '.')));
          if (isNaN(val)) return ctrl.min;

          if (val && val < ctrl.min) {
            if (ctrl.isModalButton || ctrl.isCartButton) {
              return 0;
            }
            val = ctrl.min;
          }
          if (ctrl.step !== 1) {
            var inc = double(val - ctrl.cartQuantity),
              rest = double(double((ctrl.cartQuantity + inc) * 100) % double(ctrl.step * 100)) / 100;
            inc = double(inc - rest);
            if (double(ctrl.cartQuantity + inc) < ctrl.min) {
              inc = double(inc + ctrl.step);
            }
            val = double(ctrl.cartQuantity + inc);
          }
          return val;
        }

        function watchValue() {
          if (ctrl.isChanged) return;
          ctrl.isChanged = true;
          unwatch = $scope.$watch('$ctrl.quantity', changedValue);
        }

        function changedValue() {
          ctrl.active = ctrl.quantity > 0 || ctrl.quantity === '';
          $timeout.cancel(addTimeout);

          if (ctrl.quantity === '' || ctrl.quantity === ctrl.cartQuantity) return false;

          addTimeout = $timeout(function () {
            if (ctrl.isModalButton && ctrl.modalItem) {
              ctrl.price.prices = ctrl.modalItem.prices;
              ctrl.modalItem.Price = AppService.getProductPrice(ctrl.price, ctrl.quantity);
              ctrl.modalItem.quantity = ctrl.quantity;
              if (ctrl.quantity === 0) {
                ModalService.close();
              }
            }
            var inc = (ctrl.quantity * 100 - ctrl.cartQuantity * 100) / 100;
            ctrl.cartQuantity = inc;
            if (typeof ctrl.action !== 'undefined') {
              ctrl.addToCart(ctrl.action({ qty: ctrl.quantity, inc: inc }), ctrl.quantity);
            } else if (ctrl.quantity % ctrl.step != 0) {
              ctrl.addToCart(getProductsToAdd((ctrl.quantity / ctrl.step) * ctrl.step, 0), (ctrl.quantity / ctrl.step) * ctrl.step);
            } else {
              ctrl.addToCart(getProductsToAdd(ctrl.quantity, inc), ctrl.quantity);
            }
            addTimeout = null;
          }, 800, false);
        }

        function getProductsToAdd(qty, inc) {
          return [
            {
              idLine: ctrl.idLine,
              Comment: ctrl.commentLine || '',
              idProduct: ctrl.id,
              Price: AppService.getProductPrice(ctrl.price, qty),
              costTTC: 0,
              costHT: 0,
              showTTCPrice: showTTCPrice,
              quantity: inc,
              min: ctrl.min,
              step: ctrl.step,
              designation: ctrl.designation,
              img: ctrl.img,
              URL: ctrl.url
            }
          ];
        }

        function addToCart(products, quantity) {
          ctrl.showLoader = true;

          if (!ctrl.isCartButton && !ctrl.toastAdd && !ctrl.isInCart && $location.path() !== '/' + RoutesService.getUrlByName('Cart')) {
            ModalService.close();
            ModalService.show(
              '/Template/Modal/ModalAddToCart',
              products,
              null,
              'modalAddToCartCtrl',
              null,
              null,
              {
                cartLink: '/' + RoutesService.getUrlByName('Cart')
              }
            );
          } else {
            if (!ctrl.isModalButton && !ctrl.toastAdd) {
              ModalService.close();
            }
            var mess = quantity === 0 ? ctrl.titleDeleteOk : ctrl.titleModifyOk;
            toastr.success(ctrl.designation, mess, {
              allowHtml: true,
              extraData: {
                template: 'toast_addtocart.tpl',
                data: {
                  img: products[0].img
                }
              }
            });
          }

          if (ctrl.isQuotationButton) {
            addToQuotationAction(products);
          } else {
            addToCartAction(products);
          }
        }

        function addToCartAction(products) {
          AppService.addToCart(products)
            .then(function (response) {
              ctrl.showLoader = false;
              if (response.status === 'OK') {
                AppService.updateParams(response.results);
              } else {
                AppService.getTranslate()
                  .then(function (translate) {
                    toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                      allowHtml: true,
                      extraData: {
                        template: 'toast_message.tpl'
                      }
                    });
                  });
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function addToQuotationAction(products) {
          QuotationService
            .addToQuotation(ctrl.id, ctrl.idQuotation, '', products[0].quantity)
            .then(function (response) {
              ctrl.showLoader = false;
              if (response.status === 'OK') {
                setItemQuantity(ctrl.quantity);
              } else {
                AppService.getTranslate()
                  .then(function (translate) {
                    toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                      allowHtml: true,
                      extraData: {
                        template: 'toast_message.tpl'
                      }
                    });
                  });
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function removeCartLine(products, quantity) {
          AppService.itemQuantityInCart(ctrl.id)
            .then(function (value) {
              if (value === (products[0].quantity * -1)) {
                unwatch();
                ModalService.show(
                  '/Template/Cart/ModalDeleteConfirm',
                  {
                    action: function () {
                      AppService.deleteLine(ctrl.idLine, ctrl.designation, ctrl.img, ctrl.titleDeleteOk);
                    },
                    cancel: function () {
                      setItemQuantity(value);
                      ctrl.isChanged = false;
                      watchValue();
                    }
                  },
                  null,
                  'deleteConfirmModalCtrl'
                );
              } else {
                addToCart(products, quantity);
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function removeQuotationLine() {
          unwatch();
          ModalService.show(
            '/Template/Account/ModalRemoveQuotationLine',
            {
              action: function () {
                removeQuotationLineAction(ctrl.idLine, ctrl.idQuotation);
              },
              cancel: function () {
                setItemQuantity(ctrl.productQuantity);
                ctrl.isChanged = false;
                watchValue();
              }
            },
            null,
            'modalRemoveQuotationLineCtrl'
          );
        }

        function removeQuotationLineAction(idLine, idQuotation) {
          QuotationService
            .removeQuotationLine(idLine, idQuotation)
            .then(function (response) {
              if (response.status === 'OK') {
                var index = _.findIndex(ctrl.quotationCtrl.quotations, { IDFolder: idQuotation });
                ctrl.quotationCtrl.quotations.splice(index, 1, response.folder);

                AppService.getTranslate()
                  .then(function (translate) {
                    toastr.success('', translate.messages.QuotationProductRemoved, {
                      allowHtml: true,
                      extraData: {
                        template: 'toast_message.tpl'
                      }
                    });
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function double(n) {
          return parseFloat(n.toFixed(2));
        }
      }]
    });
})();
